// File Metadata:
// Filename: NewDeparturePicture.js
// Version: 1.00
// Created: 2025-03-22 02:47:32
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Modal,
    Typography
} from '@mui/material'
import { Box } from '@mui/system'
import React, { Component } from 'react'
import { nanoid } from 'nanoid'
import CameraIcon from '@mui/icons-material/Camera'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
import Camera from '../../../components/Camera'

export class NewDeparturePicture extends Component {
    state = {
        errMsg: '',
        files: this.props.values.departureImages || [],
        open: false
    }

    next = e => {
        e.preventDefault()
        // Make photos optional for departure
        this.props.handleValue('departureImages', this.state.files)
        this.props.nextStep()
    }

    back = e => {
        e.preventDefault()
        this.props.prevStep()
    }

    handleCapture = photo => {
        const item = {
            img: photo,
            name: nanoid() + '.jpg'
        }
        this.setState(prevState => ({
            files: [...prevState.files, item],
            open: false,
            errMsg: ''
        }))
    }

    handleCameraError = (errorMessage) => {
        this.setState({ 
            errMsg: errorMessage,
            open: false 
        })
        
        // Auto-retry for mobile devices
        if (/mobile/i.test(navigator.userAgent)) {
            setTimeout(() => {
                this.setState({ open: true, errMsg: '' })
            }, 1000)
        }
    }

    handleRemove = index => {
        const newFiles = this.state.files.filter((_, i) => i !== index)
        this.setState({ files: newFiles })
    }

    render() {
        return (
            <>
                <Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
                    <CardHeader 
                        title='Take Departure Pictures' 
                        action={
                            <IconButton onClick={() => this.setState({ open: true })}>
                                <CameraIcon />
                            </IconButton>
                        }
                    />
                    <CardContent>
                        {this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Optional: Take pictures of the loaded goods
                        </Typography>
                        <Box sx={{ margin: 1 }}>
                            <ImageList sx={{ maxWidth: 340 }} cols={3}>
                                {this.state.files.map((item, i) => (
                                    <ImageListItem key={i}>
                                        <img src={item.img} alt={item.name} />
                                        <ImageListItemBar
                                            position="top"
                                            actionIcon={
                                                <IconButton onClick={() => this.handleRemove(i)}>
                                                    <RemoveCircle />
                                                </IconButton>
                                            }
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        </Box>
                        <ButtonGroup fullWidth variant='contained'>
                            <Button onClick={this.back}>Back</Button>
                            <Button onClick={this.next}>
                                {this.state.files.length > 0 ? 'Next' : 'Skip'}
                            </Button>
                        </ButtonGroup>
                    </CardContent>
                </Card>
                <Modal 
                    open={this.state.open} 
                    onClose={() => this.setState({ open: false })}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Box sx={style}>
                        <Camera 
                            onTakePhoto={this.handleCapture}
                            onError={this.handleCameraError}
                            onClose={() => this.setState({ open: false })}
                        />
                    </Box>
                </Modal>
            </>
        )
    }
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
    overflow: 'hidden'
}

export default NewDeparturePicture
